//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configuracaoNotificacaoEmailResource from '../../common/resources/configuracao/configuracao-notificacao-email';

export default {
  name: 'configuracaoNotificacaoEmail',
  data() {
    return {
      configuracaoNotificacaoEmailResources: configuracaoNotificacaoEmailResource(this.$resource),
      emailErrors: {
        negociacao: { numero: [], email: [] },
        apuracao: { numero: [], email: [] },
        pagamento: { numero: [], email: [] },
      },
      negociacao: [
        {
          status: 'label.status_em_cadastro',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'NEGOCIACAO-EM-CADASTRO',
        },
        {
          status: 'label.status_em_aprovacao',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'NEGOCIACAO-EM-APROVACAO',
        },
        {
          status: 'label.status_em_analise',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'NEGOCIACAO-EM-ANALISE',
        },
      ],
      apuracao: [
        {
          status: 'label.status_em_apuracao',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'APURACAO-EM-APURACAO',
        },
        {
          status: 'label.status_em_aprovacao',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'APURACAO-EM-APROVACAO',
        },
        {
          status: 'label.status_em_analise',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'APURACAO-EM-ANALISE',
        },
      ],
      pagamento: [
        {
          status: 'label.status_em_pendente_integracao',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'PAGAMENTO-PENDENTE-INTEGRACAO',
        },
        {
          status: 'label.status_em_aguardando_pagamento',
          valorParametro: '',
          enviarAlternativo: false,
          emailAlternativo: '',
          chaveParametro: 'PAGAMENTO-AGUARDANDO-PAGAMENTO',
        },
      ],
    };
  },
  methods: {
    validarCampos() {
      // Reinicia os erros
      this.emailErrors = {
        negociacao: { numero: [], email: [] },
        apuracao: { numero: [], email: [] },
        pagamento: { numero: [], email: [] },
      };

      const validarEmail = (item, tipo, index) => {
        if (item.enviarAlternativo) {
          if (!item.emailAlternativo) {
            this.emailErrors[tipo].email[index] = 'O e-mail é obrigatório.';
          } else {
            const emails = item.emailAlternativo.split(',').map(email => email.trim());
            const invalidEmails = emails.filter(email => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));

            if (invalidEmails.length > 0) {
              this.emailErrors[tipo].email[index] = `Os seguintes e-mails são inválidos: ${invalidEmails.join(', ')}`;
            } else {
              this.emailErrors[tipo].email[index] = '';
            }
          }
        } else {
          this.emailErrors[tipo].email[index] = '';
        }
      };

      const validarNumero = (item, tipo, index) => {
        const valor = item.valorParametro;

        if (!valor) {
          this.emailErrors[tipo].numero[index] = 'O campo número é obrigatório.';
        } else if (!Number.isInteger(Number(valor)) || Number(valor) <= 0) {
          this.emailErrors[tipo].numero[index] = 'O valor deve ser um número inteiro positivo.';
        } else {
          this.emailErrors[tipo].numero[index] = '';
        }
      };

      // Aplica a validação para cada item
      this.negociacao.forEach((negociacao, index) => {
        validarEmail(negociacao, 'negociacao', index);
        validarNumero(negociacao, 'negociacao', index);
      });

      this.apuracao.forEach((apuracao, index) => {
        validarEmail(apuracao, 'apuracao', index);
        validarNumero(apuracao, 'apuracao', index);
      });

      this.pagamento.forEach((pagamento, index) => {
        validarEmail(pagamento, 'pagamento', index);
        validarNumero(pagamento, 'pagamento', index);
      });
    },
    requestAtualizar() {
      this.validarCampos();
      const hasErrors = Object.values(this.emailErrors).some(group => (
          group.numero.some(error => error !== '') ||
          group.email.some(error => error !== '')
        ));

      if (hasErrors) {
        this.$toast.create('Corrija os erros antes de salvar.', 'snack', 3000);
        return; // Impede o envio se houver erros
      }
      if (hasErrors) {
        this.$toast.create('Corrija os erros antes de salvar.', 'snack', 3000);
        return; // Impede o envio se houver erros
      }
      const payload = [
        ...this.negociacao,
        ...this.apuracao,
        ...this.pagamento,
      ].map(item => ({
        chaveParametro: item.chaveParametro,
        valorParametro: item.valorParametro,
        enviarAlternativo: item.enviarAlternativo,
        emailAlternativo: item.emailAlternativo,
      }));

      this.configuracaoNotificacaoEmailResources
        .atualizar(payload)
        .then(() => {
          this.$toast.create(
            this.$t('message.atualizado_confira_tabela'),
            'snack',
            3000,
          );
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestPopular() {
      this.configuracaoNotificacaoEmailResources.pesquisar()
        .then((response) => {
          const objeto = response.data;

          if (!objeto || !objeto.length) return;

          const mapeamento = (dados, chaveBase) =>
            dados
              .filter(el => el.chaveParametro.startsWith(chaveBase))
              .map(el => ({
                status: this.mapeiaStatus(el.chaveParametro),
                valorParametro: el.valorParametro === 'true' ? true : el.valorParametro,
                enviarAlternativo: el.enviarAlternativo || false,
                emailAlternativo: el.emailAlternativo || '',
                chaveParametro: el.chaveParametro,
              }));

          this.negociacao = mapeamento(objeto, 'NEGOCIACAO');
          this.apuracao = mapeamento(objeto, 'APURACAO');
          this.pagamento = mapeamento(objeto, 'PAGAMENTO');
        })
        .catch((error) => {
          this.$error(this, error);
        });
    },
    mapeiaStatus(chaveParametro) {
      const mapeamentoStatus = {
        'NEGOCIACAO-EM-CADASTRO': 'label.status_em_cadastro',
        'NEGOCIACAO-EM-APROVACAO': 'label.status_em_aprovacao',
        'NEGOCIACAO-EM-ANALISE': 'label.status_em_analise',
        'APURACAO-EM-APURACAO': 'label.status_em_apuracao',
        'APURACAO-EM-APROVACAO': 'label.status_em_aprovacao',
        'APURACAO-EM-ANALISE': 'label.status_em_analise',
        'PAGAMENTO-PENDENTE-INTEGRACAO': 'label.status_em_pendente_integracao',
        'PAGAMENTO-AGUARDANDO-PAGAMENTO': 'label.status_em_aguardando_pagamento',
      };

      return mapeamentoStatus[chaveParametro] || chaveParametro;
    },

    cancelar() {
      this.requestPopular();
    },
  },
  mounted() {
    this.requestPopular();
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/ConfiguracaoNotificacaoEmail.vue?vue&type=script&lang=js&